import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navigation from "./navigation";
import Footer from "./footer";
import { Editor, EditorState, convertFromRaw } from "draft-js";
import "./EventDetail.css";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  useEffect(() => {
    fetchBlog();
    // eslint-disable-next-line
  }, [id]);

  const fetchBlog = async () => {
    try {
      const response = await fetch(`${API_URL}/api/blogs/${id}/`);
      if (response.ok) {
        const data = await response.json();
        setBlog(data);
        if (data.body) {
          try {
            setEditorState(EditorState.createWithContent(convertFromRaw(typeof data.body === 'string' ? JSON.parse(data.body) : data.body)));
          } catch {
            setEditorState(EditorState.createEmpty());
          }
        }
        if (data.thumbnail) {
          document.querySelector('.hero-section2').style.backgroundImage = `url(${data.thumbnail})`;
        } else {
          document.querySelector('.hero-section2').style.height = '80px';
          document.querySelector('.hero-section2').innerHTML = '<h1 class="page-title">Blog Detail</h1>';
        }
      } else {
        // setError('Failed to fetch blog');
      }
    } catch (err) {
      // setError('Network error while fetching blog');
    } finally {
      // setLoading(false);
    }
  };

  const formatBlogDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div className="">
      <div style={{ position: 'relative', width: '100%', zIndex: 1000 }}>
            <div className="fixed top-0 left-0 right-0 z-50">
  <Navigation />
</div>
      </div>
      <div className="hero-section2" 
      style={{ backgroundSize: 'cover', backgroundPosition: 'center' , backgroundRepeat: 'no-repeat', height: '85vh' , backgroundAttachment: 'fixed' }}
      >
        {/* <div className="page-title">Blog Details</div> */}
      </div>
      <div className="max-width">
        <div className="section-margin-half"></div>
        <div className="event-detail-containera">
          <div className="event-detail-header">
            <h1 className="text-xl font-bold text-gray-900 sm:text-2xl md:text-3xl lg:text-4xl">
  {blog?.title}
</h1>
          </div>
          <div className="event-detail-meta">
            <span>{formatBlogDate(blog?.created_at)}</span>
            <span className="event-categorya">{blog?.category}</span>
          </div>
          {/* {blog?.thumbnail && <img src={blog.thumbnail} alt={blog.title} className="event-detail-thumbnail" />} */}

          <div className="event-detail-body">
            <Editor editorState={editorState} readOnly={true} />
          </div>

          <div className="section-margin-half"></div>

          <div className="event-detail-images">
            {blog?.images && blog.images.map(img => (
              <img key={img.id} src={img.url || img.image || img} alt="blog" className="event-detail-image" />
            ))}
          </div>

        </div>
        <div className="section-margin"></div>
        <div style={{ margin: '20px 0' }}>
          <Link to="/news" className="btn-secondary">Back to News</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
